import { module } from 'angular';
import { GmcSelect3Component } from './gmc-select-3.component';

export const GmcSelect3Module = module('app.shared.gmc-select3', [])
  .component('gmcSelect3', GmcSelect3Component);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-3/gmc-select-3.module.ts